import { CourseContent } from '@bm-js/atlascloud-shared'
import Input from './Input'

type Props = {
  content: CourseContent
  setContentData: (data: CourseContent['data']) => void
}

const CourseEditableHeader = ({ content, setContentData }: Props) => {
  return (
    <div>
      <Input
        type='text'
        value={content.data.text}
        onChange={(e) =>
          setContentData({ ...content.data, text: e.target.value })
        }
        placeholder='Rubriktext'
      />
    </div>
  )
}

export default CourseEditableHeader
